'use client'

import * as React from 'react'
import * as SwitchPrimitive from '@radix-ui/react-switch'
import {cn} from '~/design-system/utils'

export type ToggleProps = Omit<
  React.ComponentProps<typeof SwitchPrimitive.Root>,
  'className'
> & {
  classNames?: {
    root?: string
    thumb?: string
  }
}

export default function Toggle({classNames, ...props}: ToggleProps) {
  return (
    <SwitchPrimitive.Root data-slot="switch" className={classNames?.root} {...props}>
      <SwitchPrimitive.Thumb
        data-slot="switch-thumb"
        className={cn(
          'pointer-events-none block transition-transform data-[state=checked]:translate-x-full data-[state=unchecked]:translate-x-0',
          classNames?.thumb
        )}
      />
    </SwitchPrimitive.Root>
  )
}
